module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/wizard.cc716c5c.png";